var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiHeader, UiButton, UiIcon, UiSpinner } from '@claims-ia/design-system';
import LanguageSelector from '@declaration/components/LanguageSelector.vue';
import { brandAsset } from '@declaration/environment/brandAsset';
import { DEFAULT_HIDE_CLOSE_BUTTON_STEPS } from '@declaration/layout';
import { closingStatus } from '@declaration/claim/status';
import { ClaimLanguage } from '@shared/types/api/user';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
import { closeCountingIframe } from '@declaration/utils/counting-mode';
const layout = namespace('layout');
const authentication = namespace('authentication');
const pages = namespace('pages');
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let Header = class Header extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.languages = Object.values(ClaimLanguage);
        this.svgLogo = brandAsset('header_logo.svg');
        this.pngLogo = brandAsset('header_logo.png');
        this.logoSrc = '';
        this.closingStatutes = closingStatus;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    mounted() {
        this.logoSrc = this.svgLogo;
    }
    onImageError() {
        if (this.logoSrc !== this.pngLogo) {
            this.logoSrc = this.pngLogo;
        }
    }
    close() {
        if (this.closeCallback === null)
            return;
        if (typeof this.closeCallback === 'string') {
            this.$goToLocalePath(this.closeCallback);
            return;
        }
        this.closeCallback(this);
    }
    async goBack() {
        if (this.goBackCallback === null)
            return;
        const res = this.goBackCallback(this);
        if (res instanceof Promise) {
            this.isLoading = true;
            await res;
            this.isLoading = false;
        }
    }
    finish() {
        closeCountingIframe();
    }
    async logout() {
        await this.dispatchLogoutAction();
        await this.$router.push('/');
    }
    get isClosingStatus() {
        return this.closingStatutes.includes(this.currentStatus);
    }
    get shouldDisplayClose() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (
        // Hide button when no callback
        !this.closeCallback ||
            // Or not on declaration page
            this.localePath(this.$route.path) !== this.localePath({ name: 'declaration' })) {
            return false;
        }
        // Hide close button on configured steps
        const hideOnSteps = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.closeCallBackBtnBehavior) === null || _c === void 0 ? void 0 : _c.hideOnSteps) !== null && _d !== void 0 ? _d : DEFAULT_HIDE_CLOSE_BUTTON_STEPS;
        if (hideOnSteps.includes(this.currentStep))
            return false;
        return (
        // If no magic link, show close button
        !this.magicLink ||
            // Else, show close button only if insurer config allows it
            !!((_g = (_f = (_e = this.selfCareSettings) === null || _e === void 0 ? void 0 : _e.declaration) === null || _f === void 0 ? void 0 : _f.closeCallBackBtnBehavior) === null || _g === void 0 ? void 0 : _g.showCloseBtnIfMagicLink));
    }
    get shouldDisplayBack() {
        return !!this.goBackCallback && !this.isPreviousStepLocked && !this.isClosingStatus;
    }
    get shouldDisplayLanguages() {
        return insurerHasFeature(InsurerFeatureFlag.LanguageSelection) && this.accessToken !== null;
    }
    get shouldDisplayFinish() {
        return insurerHasFeature(InsurerFeatureFlag.ShowFinishButton);
    }
    get shouldHideLogoInHeader() {
        return insurerHasFeature(InsurerFeatureFlag.HideLogoInHeader);
    }
    get textColor() {
        return this.isMobile ? this.color.mobileHeaderColor : this.color.headerColor;
    }
};
__decorate([
    qualification.State('qualification')
], Header.prototype, "qualification", void 0);
__decorate([
    layout.State('closeCallback')
], Header.prototype, "closeCallback", void 0);
__decorate([
    layout.State('goBackCallback')
], Header.prototype, "goBackCallback", void 0);
__decorate([
    layout.State('color')
], Header.prototype, "color", void 0);
__decorate([
    layout.State('isMobile')
], Header.prototype, "isMobile", void 0);
__decorate([
    layout.State('title')
], Header.prototype, "title", void 0);
__decorate([
    layout.Getter('isDesktop')
], Header.prototype, "isDesktop", void 0);
__decorate([
    pages.Getter('isPreviousStepLocked')
], Header.prototype, "isPreviousStepLocked", void 0);
__decorate([
    authentication.Action('logout')
], Header.prototype, "dispatchLogoutAction", void 0);
__decorate([
    authentication.State('magicLink')
], Header.prototype, "magicLink", void 0);
__decorate([
    authentication.State('accessToken')
], Header.prototype, "accessToken", void 0);
__decorate([
    claim.Getter('currentStep')
], Header.prototype, "currentStep", void 0);
__decorate([
    claim.Getter('currentStatus')
], Header.prototype, "currentStatus", void 0);
__decorate([
    settings.Getter('setting')
], Header.prototype, "setting", void 0);
Header = __decorate([
    Component({
        components: { UiHeader, UiButton, UiIcon, UiSpinner, LanguageSelector },
    })
], Header);
export default Header;
